import { http } from './http';

/**
 * READ (list) — adapter shaped for useListQuery
 * params: { page, size, sortBy, sortDir, q, filters:{ category, frequency } }
 * returns: { rows, total }
 */
export async function readIndicators(params) {
    const { filters, ...flatParams } = params || {};
    const requestParams = { ...flatParams, ...(filters || {}) };
    const { data } = await http.get('/indicators', { params: requestParams });
    const raw = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);

    const rows = raw.map(x => ({
        id: x.indicatorId,
        name: x.name,
        description: x.description,
        unit: x.unit,
        frequency: x.frequency,
        category: x.category,
        ...x,
    }));

    const total = Number.isFinite(data?.total) ? data.total : (data?.meta?.total ?? rows.length);

    return { rows, total };
}

/** READ (single) */
export async function getIndicator(id, { etag } = {}) {
    const { data, etag: nextEtag } = await http.get(`/indicators/${id}`, { etag });
    const result = data && typeof data === 'object'
        ? { id: data.indicatorId, ...data }
        : data;
    return { data: result, etag: nextEtag };
}

/** CREATE */
export const createIndicator = (payload) =>
    http.post('/indicators', { body: payload }).then(r => r.data);

/** UPDATE (partial) */
export const updateIndicator = (id, patch) =>
    http.patch(`/indicators/${id}`, { body: patch }).then(r => r.data);

/** REPLACE (full) */
export const replaceIndicator = (id, body) =>
    http.put(`/indicators/${id}`, { body }).then(r => r.data);

/** DELETE */
export const deleteIndicator = (id) =>
    http.delete(`/indicators/${id}`).then(() => ({ ok: true }));

/** Taxonomies / helpers */
export const listIndicatorCategories = () =>
    http.get('/indicators/categories').then(({ data }) => (Array.isArray(data) ? data : []));

export const listIndicatorFrequencies = () =>
    http.get('/indicators/frequencies').then(({ data }) => (Array.isArray(data) ? data : []));

export const listIndicatorUnits = () =>
    http.get('/indicators/units').then(({ data }) => (Array.isArray(data) ? data : []));

export async function readAllIndicators() {
    const first = await readIndicators({ page: 1, size: 500, sortBy: 'category', sortDir: 'asc' });
    return first.rows || [];
}
